import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import "@/App.css";
import { AuthProvider } from "@/context/AuthContext";
import { ColorModeProvider, useColorMode } from "@/context/ColorModeContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Projects from "@/pages/Projects";
import NewSimulation from "@/pages/NewSimulation";
import Crm from "@/pages/Crm";
import ProjectDetail from "@/pages/ProjectDetail";
import Comparator from "@/pages/Comparator";
import Catalogue from "@/pages/Catalogue";
import PriceSchedule from "@/pages/PriceSchedule";
import Admin from "@/pages/Admin";

const NewSimulationRoute = () => <NewSimulation key={useLocation().key} />;
const ThemedToaster = () => <Toaster position="top-right" richColors theme={useColorMode().mode} />;

function App() {
  return (
    <div className="App">
      <ColorModeProvider>
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route element={<ProtectedRoute />}>
              <Route element={<Layout />}>
                <Route path="/" element={<Dashboard />} />
                <Route path="/simulation/new" element={<NewSimulationRoute />} />
                <Route path="/projects" element={<Projects />} />
                <Route path="/projects/:id" element={<ProjectDetail />} />
                <Route path="/catalogue" element={<Catalogue />} />
                <Route path="/comparateur" element={<Comparator />} />
                <Route path="/prix" element={<PriceSchedule />} />
                <Route path="/admin" element={<Admin />} />
                <Route path="/crm" element={<Crm />} />
              </Route>
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
        <ThemedToaster />
      </AuthProvider>
      </ColorModeProvider>
    </div>
  );
}

export default App;
